<template>
  <div>
    <template v-if="isEntryRoute">
      <entity-entry-header :entityKey="eCurrent.key" :title="$t(`views.procurement.title`)"/>
    </template>
    <loader v-if="isLoading"/>

    <template v-if="isEntryRoute">
      <entity-entry-table :entityKey="eCurrent.key" :tableSettings="table" searchable>
        <template #cell(procurementstate)="data">
          <b-badge v-if="data.cell.item.procurementstate === 'failed'" variant="danger">{{data.cell.item.procurementstate}}</b-badge>
          <b-badge v-else-if="data.cell.item.procurementstate === 'inqueue'" variant="warning">{{data.cell.item.procurementstate}}</b-badge>
          <b-badge v-else-if="data.cell.item.procurementstate === 'new'" variant="warning">{{data.cell.item.procurementstate}}</b-badge>
          <b-badge v-else variant="dark">{{data.cell.item.procurementstate}}</b-badge>
        </template>

         <template #cell(orderdate)="data">
          {{ formatDate(data.cell.item.orderdate) }}
        </template>
      </entity-entry-table>
    </template>
    <section v-else-if="isDetailRouteWithParameter">
      <router-view />
    </section>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

import { CLASS_TABLE_FIELD_KEY_UNKNOWN } from '@/assets/js/config/client'

import { TableHelper } from '@/assets/js/helper/table'

import MixinEntityBaseSearchOnly from '@/components/mixins/EntityBaseSearchOnly'
import EntityEntryHeader from '@/components/entity/EntryHeader'
import EntityEntryTable from '@/components/entity/EntryTable'

import moment from 'moment'

const ENTITY_KEY = 'procurementmessages'

export default {
  name: 'ProcurementMessages',
  mixins: [MixinEntityBaseSearchOnly],
  components: {
    EntityEntryHeader,
    EntityEntryTable,
    Loader
  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      isLoading: false,
      table: {
        helper: TableHelper,
        mapper: this.tableEntitiesMapper,
        options: {
          fields: {
            includes: [],
            excludes: [],
            sorting: [CLASS_TABLE_FIELD_KEY_UNKNOWN, 'requiredactions'],
            labelKey: `views.${this.$options.name.toLowerCase()}.table.label.{field}`,
            class: {
              requiredactions: 'cell-align-right'
            },
            thClass: {
              requiredactions: 'cell-min cell-nowrap'
            }
          }
        },
        events: {
          rowClicked: this.tableRowClicked
        }
      }
    }
  },
  computed: {
    isEntryRoute () {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    },
    isDetailRouteWithParameter () {
      return this.$route.matched[this.$route.matched.length - 1].path.indexOf(`/:${this.eCurrent.paramKey}`) >= 0
    },
    isDetailRouteWithoutParameter () {
      return !this.isEntryRoute && !this.isDetailRouteWithParameter
    }
  },
  methods: {
    tableEntitiesMapper (entities, definition) {
      return entities
        .map(e => Object.assign({}, e, {
          $routerLink: {
            name: `${this.$options.name}.Detail`,
            params: {
              [this.eCurrent.paramKey]: e.correlationalid
            }
          }
        }))
    },
    tableRowClicked (entity) {
      this.$router.push(entity.$routerLink)
    },
    formatDate (date) {
      return moment(new Date(date)).format('DD.MM.YYYY, HH:mm:ss')
    }
  },
  created () {
    TableHelper.rowClassHook(entity => entity.$routerLink ? 'has-routerlink' : null)
  }
}
</script>

<style lang="scss"></style>
